import {useState, useEffect} from 'react';
import {Table} from 'antd';
import {toFSDateTime} from "../../util/timeutils";
import {TextChangeWidget} from "../widget/TextChangeWidget";
import {updateTaskNote} from "../../api/Api";

export const TaskNotesTable = ({session, notes, onRefresh, props}) => {
    const defaultPageSize = 50;
    const [pageSize, setPageSize] = useState(defaultPageSize)
    const [currentPage, setCurrentPage] = useState(1);

    useEffect(() => {
        if (notes.length) {
            const defaultCurrent = notes.length ? Math.ceil( notes.length / pageSize ) : 1;
            setCurrentPage(defaultCurrent);
        }
    }, [notes.length, pageSize]);

    const onNotesChange = (record) => (newNotes) => {
        updateTaskNote(record.taskId, record.id, newNotes).then(r => {
            if (onRefresh) onRefresh();
        }).catch(e => {
            console.log(`failed to update notes`);
        })
    }

    const columns = [
        {
            title: 'Notes',
            dataIndex: 'notes',
            key: 'notes',
            render: (val, record) => {
                if (session.id === record.userId) {
                    return <TextChangeWidget text={val} maxLength={2048} rows={4} onTextSave={onNotesChange(record)}/>
                } else {
                    // do not allow edits
                    return val;
                }
            }
        },
        {
            title: 'Author',
            dataIndex: 'firstname',
            key: 'author',
            render: (val, record, index) => {
                return `${record.firstname} ${record.lastname}`;
            }
        },
        {
            title: 'Timestamp',
            dataIndex: 'timestamp',
            key: 'timestamp',
            render: (val) => {
                return toFSDateTime(new Date(val));
            }
        },
    ];

    const onTableSizeChange = (page, size) => {
        setPageSize(size);
    }

    const onTableChange = (page, size) => {
        setCurrentPage(page);
    }

    const tablePagination = {
        defaultPageSize: defaultPageSize,
        current: currentPage,
        showSizeChanger: true,
        pageSizeOptions: [50, 100, 150, 200],
        onShowSizeChange: onTableSizeChange,
        onChange: onTableChange,
    }

    return <Table dataSource={notes} columns={columns} pagination={tablePagination} />
}